import styled from "styled-components";

import { Modal } from "components/Modal";

export const HelpCenterContainer = styled.div`
  margin-top: 10px;

  .wrapper {
    padding: 18px 15px;
    background: ${({ theme }) => theme.card.bg.primary};
    border-radius: 10px;
    border: 1px solid ${({ theme }) => theme.card.border.primary};

    h2 {
      font-size: 24px;
      font-weight: 500;
    }

    p {
      font-weight: 400;
      font-size: 14px;
      color: #717184;
    }

    .close-icon {
      cursor: pointer;
    }

    .option-wrapper {
      display: flex;
      gap: 14px;

      img {
        width: 37px;
        height: 37px;
      }

      .name {
        font-size: 14px;
        font-weight: 500;
      }

      .description {
        font-size: 12px;
        font-weight: 400;
      }
    }
  }

  .center-container {
    width: 550px;
    height: 100%;

    &.invisible {
      width: 50px;
    }
  }

  .list-group-item {
    background: ${({ theme }) => theme.global.bg.quinary};
    color: ${({ theme }) => theme.global.extraInfo.font.color};
    border: 1px solid ${({ theme }) => theme.card.border.primary};
    border-radius: 93px;
    margin-bottom: 16px;
    padding: 9px 12px 11px 15px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;

    .option-wrapper svg {
      circle {
        fill: ${({ theme }) => theme.input.bg.search};
      }
      path {
        fill: ${({ theme }) => theme.global.extraInfo.font.color};
      }
    }

    &.activeItem {
      background: ${({ theme }) => theme.aside.bg.secondary};

      svg {
        circle {
          fill: #048af5;
        }
        path {
          fill: #fff;
        }
      }

      .name {
        color: #048af5;
      }

      .description {
        color: ${({ theme }) => theme.input.placeholder.secondary};
      }
    }

    & + .list-group-item {
      border-top-width: 1px;
    }
  }

  .desktop-view {
    display: none;
  }

  .mobile-view {
    display: none;
  }

  @media (max-width: 1299px) {
    .wrapper {
      width: 100%;
      margin-bottom: 12px;
    }

    .app__animated {
      width: 370px;
    }
  }

  @media (max-width: 1025px) and (min-width: 768px) {
    .app__animated {
      width: 270px;
    }
  }

  @media (min-width: 769px) {
    .desktop-view {
      display: flex;
      justify-content: center;
      width: 100%;
    }
  }

  @media (max-width: 768px) {
    .mobile-view {
      display: flex;
      flex-direction: column;
      .center-container {
        position: unset;
        width: 100%;
      }
      .bottom-menu {
        margin-top: 10px;
      }
    }
  }
`;

export const HelpCenterSubCardContainer = styled.div`
  .wrapper {
    padding: 0;
    background: ${({ theme }) => theme.card.bg.primary};
    border-radius: ${({ theme }) => theme.constants.BORDER_RADIUS_8};

    .bug-description-input {
      textarea {
        border-radius: 10px;
      }
    }
    p {
      margin-bottom: 0px;
    }

    .header {
      padding: 15px;
      border-radius: 10px 10px 0px 0px;

      h2 {
        margin-bottom: 0;
        font-weight: 500;
        font-size: 20px;
      }

      .close-icon {
        position: absolute;
        right: 10px;
        top: 17px;
      }
    }

    form {
      padding: 0 17px 17px;

      .form-error {
        margin-top: -20px;
        margin-left: 12px;
      }

      .btn-submit {
        text-align: center;

        button {
          width: 100%;
        }
      }
    }

    .typeform-widget {
      height: 500px;
      margin-top: -20px;

      .typeform {
        height: 100%;
        width: 100%;
        border: 0;
        border-radius: 0px;
      }
    }
  }

  .input-form .select-feature-dd svg {
    top: 12px;
  }

  @media screen and (max-width: 768px) {
    .wrapper .header {
      display: flex;

      h2 {
        width: 90%;
      }

      .close-icon {
        position: relative;
        top: 0px;
        right: 0px;
      }
    }
  }
`;

export const FAQContainer = styled.div`
  position: relative;
  .header {
    display: block;
  }

  .accordion {
    padding: 0px 18px;

    .accordion-item {
      .accordion-header {
        border-radius: 0;

        .accordion-button {
          border-radius: 0;
          margin-bottom: 0;
          font-weight: 400;
        }
      }

      button {
        font-weight: 400;
        font-size: 14px;
        padding: 10px;
        border-radius: 0;
        background: ${({ theme }) => theme.card.bg.primary};
      }
    }
  }
`;

export const UserGuideContainer = styled.div`
  .wrapper {
    padding: 30px 30px 40px;
    background: ${({ theme }) => theme.card.bg.primary};
    border-radius: ${({ theme }) => theme.constants.BORDER_RADIUS_8};

    h2 {
      text-align: center;
      font-size: ${({ theme }) => theme.constants.FONT_SIZE_18};
      margin-bottom: 2rem;
    }

    .btn-start {
      width: 114px;
      font-weight: 600;
      font-size: 14px;
      border-radius: ${({ theme }) => theme.constants.BORDER_RADIUS_8};
      padding: 8px 20px;

      .icon-play {
        margin-right: 10px;
      }
    }

    .list-group-item {
      align-items: center;
    }
  }
`;

export const UserGuideModalContainer = styled(Modal)`
  .modal-dialog {
    max-width: 974px;

    .modal-body {
      padding-bottom: 0;
      margin-top: -30px;
      text-align: center;

      h2 {
        text-align: center;
        font-size: ${({ theme }) => theme.constants.FONT_SIZE_18};
        margin-bottom: 2rem;
      }

      p {
        font-weight: 700;
        font-size: ${({ theme }) => theme.constants.FONT_SIZE_16};
        color: ${({ theme }) => theme.global.color.bodyColor};
        margin-bottom: 0px;
      }

      iframe {
        margin-top: 1rem;
        width: 100%;
        height: 384px;
      }

      button {
        border-radius: ${({ theme }) => theme.constants.BORDER_RADIUS_8};
        width: 285px;
      }
    }
  }

  @media (max-width: 768px) {
    .modal-dialog {
      max-width: 100%;
    }

    iframe {
      height: 300px;
    }
  }
`;
export const Divider = styled.div`
  border-bottom: 1px solid #d5d7da;
  margin: 20px 0px;
`;
